// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<div id="customers-merge" class="box">
    <div class="alert">
      <span>
        <strong>DISCLAIMER:</strong> Using “Merge Duplicated customers”, you can consolidate two or more customer profiles.
        All products and co-made loans belonging to the duplicate customers will be moved to the main customer. Customers must be of the same type.
      </span>
    </div>
    <div class="alert alert--danger">
      <span>
        <strong>This operation cannot be reverted.</strong> Once the customers are merged,
        the duplicate customers will be closed and only the main customer will be retained.
      </span>
    </div>

    <div>
      <input id="merged-customers-switch"
             type="checkbox"
             ng-model="\$ctrl.hideMerged"/>
      <label for="merged-customers-switch">&nbsp;Hide merged customers</label>
    </div>

    <div id="customers-merge-table">
      <table class="table">
        <thead>
        <th class="numbers">No.</th>
        <th>CIF number</th>
        <th>Mother branch</th>
        <th>Name</th>
        <th>Birth/Registration date</th>
        <th>Birth/Incorporation place</th>
        <th>Address</th>
        <th>&nbsp;</th>
        </thead>
        <tbody ng-show="!\$ctrl.hideMerged">
        <tr ng-if="\$ctrl.mergedCustomers.length > 0">
          <td colspan="8">Customers already merged in:</td>
        </tr>
        <tr class="inactive-row" ng-repeat="cst in \$ctrl.mergedCustomers track by cst.id">
          <td>{{\$index + 1}}.</td>
          <td>{{cst.customerNumber}}</td>
          <td>{{cst.branchName}}</td>
          <td>{{cst.effectiveName}}</td>
          <td>{{cst.registrationOrBirthDate | prettyDate}}</td>
          <td>{{cst.incorporationOrBirthPlace}}</td>
          <td>{{cst.address}}</td>
          <td>
          </td>
        </tr>
        </tr>
        </tbody>
        <tbody>
        <tr>
          <td colspan="8">Customers to be merged:</td>
        </tr>
        <tr ng-repeat="cst in \$ctrl.customersToMerge track by cst.id">
          <td>{{\$ctrl.mergedCustomers.length * !\$ctrl.hideMerged + \$index + 1}}.</td>
          <td>{{cst.customerNumber}}</td>
          <td>{{cst.branchName}}</td>
          <td>{{cst.effectiveName}}</td>
          <td>{{cst.registrationOrBirthDate | prettyDate}}</td>
          <td>{{cst.incorporationOrBirthPlace}}</td>
          <td>{{cst.address}}</td>
          <td>
            <button type="button"
                    class="btn btn-danger"
                    ng-click="\$ctrl.remove(cst.id)">
              Remove
            </button>
          </td>
        </tr>
        <tr>
          <td>{{\$ctrl.mergedCustomers.length * !\$ctrl.hideMerged + \$ctrl.customersToMerge.length + 1}}.</td>
          <td class="label" colspan="7">
            <customer-picker on-choose="\$ctrl.addCustomerToMergingContext(customer)" search-criteria="{customerTypes: [\$ctrl.customerType]}"></customer-picker>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="customer-merge__control-buttons buttons">
      <button type="button"
              class="btn btn-warning"
              ng-click="\$ctrl.redirectBack()">
        Cancel
      </button>
      <button type="submit"
              class="btn btn-primary"
              ng-disabled="!\$ctrl.customersToMerge || \$ctrl.customersToMerge.length === 0"
              ng-click="\$ctrl.merge()">
        Merge
      </button>
    </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/profile/merge/customer-merge-customers.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;